import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Modal from './common/modal.vue'
import { ref, RenderFunction } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'modal',
  setup(__props) {

let value = ref(false);
let content = function(h:any) {
    return h('div', {
        class: 'index__content'
    }, [
        h('span', {}, '这是content'), 
        h('span', {}, '这是第二个content')
    ]);
};
console.log(value)

let show = ():void => {
    value.value = true;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(show) && _unref(show)(...args)))
    }, "展示modal"),
    _createVNode(Modal, {
      modelValue: _unref(value),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(value) ? (value).value = $event : value = $event)),
      title: "标题",
      content: _unref(content)
    }, null, 8, ["modelValue", "content"])
  ], 64))
}
}

})